export const LINE_CLAMP_LINES = 28



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/constants.js